export default {
  local: "english",
  interactivity: {
    chapters: "Chapters",
    chapter: "Chapter",
    Poll: "Poll",
    yes: "Yes",
    no: "No",
    quiz: "Quiz",
    dont_know: "I dont know",
    question: "Question",
    sondage: "Survey",
    chaptersList: "List of chapters",
    attachment: "Attachments",
    downloadAll: "Download all",
    options: "Options",
    prevSlide: "Previous slide",
    nextSlide: "Next slide",
    viewFile: "View File",
    viewVideo: "Watch the video",
    linkNav: "Navigate through the page link",
  },
  language: {
    fr: "French",
    en: "English",
    es: "Spanish",
    it: "Italian",
    zh: "Chinese",
    ru: "Russian",
    ja: "Japanese",
    pt: "Portuguese",
    ar: "Arabic",
    hi: "Hindi",
    bn: "Bengali",
    de: "German",
    fl: "FL - original"
  },
  player: {
    in_progress: "In progress",
    Title: "In progress",
    playVid: "Play Video",
    autoplay: "autoplay",
    audio: "Audio",
    auto: "Auto",
    buffered: "Buffered",
    captions: "Captions",
    currentTime: "Current time",
    slides: "Slides",
    duration: "Duration",
    enabled: "Enabled",
    enterFullscreen: "Enter fullscreen",
    enterPiP: "Miniplayer",
    exitFullscreen: "Exit fullscreen",
    fullscreen: "Fullscreen",
    live: "Live",
    loop: "Loop",
    mute: "Mute",
    none: "None",
    normal: "Normal",
    off: "Off",
    pause: "Pause",
    pip: "Picture-in-Picture",
    play: "Play",
    replay: "Replay",
    playback: "Playback",
    playbackQuality: "Playback Quality",
    playbackRate: "Playback Rate",
    played: "Played",
    scrubberLabel: "{currentTime} of {duration}",
    adjustVol: "Adjust volume",
    advance: "Advance",
    fastBackward: "Fast Backward",
    subtitleSetting: "Subtitle settings",
    offlineVideo: "The video is offline",
    liveVideoWillStart: "The live stream will start on {date} at {hour}.",
    liveVideoIsStarting: "The live stream will start in a few moments...",
    liveVideoFinished: "The live is finished.",
    liveVideoAir: "The live stream will start soon.",
    srcprocessed: "The video source is being processed",
    sourceVide: "Empty source",
    forbiddenMedia: "This media is inaccessible.",
    privatevd: "This video is private",
    videoPause: "Pause Video",
    next: "Next",
    previous: "Previous",
  },
  modals: {
    moreInfo: "more info",
    about: "About",
    quality: "Quality",
    rate: "Speed",
    keyboardShortcuts: "Keyboard Shortcuts",
    showListOfShortcuts: "Show list of keyboard shortcuts",
    Closeallmodals: "Close all modals",
    default: "Default",
    disableCaptions: "Disable subtitles/captions",
    disabled: "Disabled",
    enableCaptions: "Enable subtitles/captions",
    functions: "Functions",
    shortcuts: "Shortcuts",
  },
  buttons: {
    menu: "Menu",
    stop: "Stop",
    send: "send",
    Continue: "Continue",
    close: "Close",
    seekBackward: "Seek backward",
    seekForward: "Seek forward",
    settings: "Settings",
    subtitlesOrCc: "Subtitles/CC",
    extractVideo: "Extract",

    liveSubtitlesOrCc: "Live Captions",
    unmute: "Unmute",
    volume: "Volume",
    confirm: "Confirm",
    rewind: "Rewind",
    next: "Next",
    download: "Download",
    disableSubtitles: "transcribed captions disabled",
    share: "Share",
    shareOn: "Share to",
    AD: "Audio description",
    ignore: "Ignore",
    valid: "Validate",
    downloadTranscript: "Download transcript",
    video: "Download video clip",
    audio: "Download audio clip",
  },
  AllTraslation: {
    searchChapter: "Search chapter",
    globalInfo: "General informations",
    socialMedia: "Social Media",
    exportVideo: "Export Video",
    permalink: "Permalink",
    copy: "Copy",
    embedCode: "Embed Code",
    color: "Color",
    startAt: "start à",
    yourEmail: "Your email",
    receiverEmail: "Receiver email",
    message: "Message",
    emailExample: "example@example.com",
    writeYourMsg: "Write your message",
    sendWithMail: "Send With Mail",
    spaceBar: "Spacebar",
    or: "or",
    seconds: "Seconds",
    exitPiP: "Expand",
    scrubber: "Scrubber",
    seekTotal: "Seek total",
    video: "Video",
    viewport: "Viewport",
    resolution: "Current resolution",
    codec: "Codec",
    host: "Host",
    speed: "Connection Speed",
    repeat: "Repeat",
    share: "Share",
    statistics: "Statistics",
    powered: "Powered by ",
    continue: "Continue",
    authentication: "Authentication",
    textAuth: "You must enter the password to view this video",
    NotfoundPage: "Page not found",
    NotfoundPageDesc: "This page you are trying to view does not exist",
    AccessDenied: "Access Forbidden",
    AccessDeniedDesc: "The server refuses to execute this request",
    AuthRequired: "Authentification Required",
    NeedAuth: "Please authenticate to the platform to continue the video",
    shuffle: "Shuffle",
    playlist: "Playlist",
    searchPlaylist: "Search",
    viewPDF: "View the pdf",
    searchTranscript: "Enter your text",
  },
};
